export default "__VITE_ASSET__BTGOZBUY__"